import { Dish } from "./Dish";
import { SignIn } from "./SignIn";
import { Search } from "./Search";
import { SignUp } from "./SignUp";
import { Filter } from "./Filter";
import { Reviews } from "./Reviews";
import { MenuList } from "./MenuList";
import { Checkout } from "./Checkout";
import { Onboarding } from "./Onboarding";
import { Promocodes } from "./Promocodes";
import { EditProfile } from "./EditProfile";
import { NewPassword } from "./NewPassword";
import { OrderFailed } from "./OrderFailed";
import { LeaveAReview } from "./LeaveAReview";
import { OrderHistory } from "./OrderHistory";
import { TrackYourOrder } from "./TrackYourOrder";
import { ForgotPassword } from "./ForgotPassword";
import { OrderSuccessful } from "./OrderSuccessful";
import { PromocodesEmpty } from "./PromocodesEmpty";
import { ConfirmationCode } from "./ConfirmationCode";
import { OrderHistoryEmpty } from "./OrderHistoryEmpty";
import { SignUpAccountCreated } from "./SignUpAccountCreated";
import { VerifyYourPhoneNumber } from "./VerifyYourPhoneNumber";
import { ForgotPasswordSentEmail } from "./ForgotPasswordSentEmail";
import { OtpScreen } from "./OtpScreen";
import { PaymentMethods } from "./PaymentMethods";
import { CustomizeItemForItemOnly } from "./CustomizeItemForItemOnly";
import { OrderSummary } from "./OrderSummary";
import { Order } from "./Order";
import { CustomizeItemForMealOnly } from "./CustomizeItemForMealOnly";
import { PointLogScreen } from "./PointLogScreen";

export const screens = {
  Dish,
  SignIn,
  Search,
  SignUp,
  Filter,
  Reviews,
  MenuList,
  Checkout,
  Onboarding,
  Promocodes,
  EditProfile,
  OrderFailed,
  NewPassword,
  LeaveAReview,
  OrderHistory,
  ForgotPassword,
  TrackYourOrder,
  OrderSuccessful,
  PromocodesEmpty,
  ConfirmationCode,
  OrderHistoryEmpty,
  SignUpAccountCreated,
  VerifyYourPhoneNumber,
  ForgotPasswordSentEmail,
  OtpScreen,
  PaymentMethods,
  CustomizeItemForItemOnly,
  OrderSummary,
  Order,
  CustomizeItemForMealOnly,
  PointLogScreen
};
